import { createAsyncThunk } from '@reduxjs/toolkit';

import type { AdminThunkConfig } from '@/types/store.types';

/**
 * Typed async thunk creator
 * Provides type safety for state and services in thunks
 */
export const createAdminAsyncThunk: ReturnType<typeof createAsyncThunk.withTypes<AdminThunkConfig>> =
  createAsyncThunk.withTypes<AdminThunkConfig>();
